import React, { SyntheticEvent } from "react";

import { Button, Form, FormField, FormGroup, Input, InputProps, Label } from "semantic-ui-react";

import { useIntl } from "react-intl";

import DateTextBox from "react-lib/apps/common/DateTextBox";

import { LoginInfo } from "./UserProfileFormBasic";

export type UserProfileDetailType = Partial<{
  birthdate: string | null;
  cid: string;
  code: string;
  dob: string;
  email: string;
  first_name: string;
  first_name_en: string;
  image: string;
  last_name: string;
  last_name_en: string;
  licence: string;
  phone_no: string;
  status: string;
  user: string;
}>;

type UserProfileFormDetailedProps = {
  isSaveLoading: boolean;
  loginInfo: LoginInfo;
  readOnly?: boolean;
  userData: UserProfileDetailType;
  onChangeValue: (e: any, data: any) => void;
  onSave: () => void;
};

const UserProfileFormDetailed: React.FC<UserProfileFormDetailedProps> = (props) => {
  const intl = useIntl();

  const handleChangeCID = (e: SyntheticEvent, data: InputProps) => {
    let value: string = data.value || "";

    value = value.replace(/\D/g, "").slice(0, 13) || "";

    props.onChangeValue(e, { ...data, value });
  };

  return (
    <Form className="form-detailed --override-disabled --grey">
      <FormGroup inline>
        <FormField width={8} inline>
          <label>MeHealth ID</label>
          <Input value={props.userData.user} readOnly />
        </FormField>
        <FormField width={1} />
        <FormField width={8} inline>
          {!!props.loginInfo.loginDisplay?.method && (
            <Label size="large">Login with {props.loginInfo.loginDisplay.method}</Label>
          )}
        </FormField>
      </FormGroup>

      <FormGroup inline>
        <FormField width={8} required>
          <label>ชื่อ</label>
          <Input
            name="first_name"
            placeholder="กรุณาระบุชื่อ"
            readOnly={props.readOnly}
            value={props.userData.first_name}
            fluid
            onChange={props.onChangeValue}
          />
        </FormField>
        <FormField width={1} />
        <FormField width={8} required>
          <label>นามสกุล</label>
          <Input
            name="last_name"
            placeholder="กรุณาระบุนามสกุล"
            readOnly={props.readOnly}
            value={props.userData.last_name}
            fluid
            onChange={props.onChangeValue}
          />
        </FormField>
      </FormGroup>

      <FormGroup inline>
        <FormField width={8} required>
          <label>Firstname</label>
          <Input
            name="first_name_en"
            placeholder="กรุณาระบุชื่อภาษาอังกฤษ"
            readOnly={props.readOnly}
            value={props.userData.first_name_en}
            fluid
            onChange={props.onChangeValue}
          />
        </FormField>
        <FormField width={1} />
        <FormField width={8} required>
          <label>Lastname</label>
          <Input
            name="last_name_en"
            placeholder="กรุณาระบุนามสกุลภาษาอังกฤษ"
            readOnly={props.readOnly}
            value={props.userData.last_name_en}
            fluid
            onChange={props.onChangeValue}
          />
        </FormField>
      </FormGroup>

      <FormGroup inline>
        <FormField width={8}>
          <label>{intl.formatMessage({ id: "เลขประจำตัวประชาชน" })}</label>
          <Input
            name="cid"
            placeholder={intl.formatMessage({ id: "กรุณาระบุเลขประจำตัวประชาชน" })}
            readOnly={props.readOnly}
            value={props.userData.cid}
            fluid
            onChange={handleChangeCID}
          />
        </FormField>
        <FormField width={1} />
        <FormField width={8} required>
          <label>{intl.formatMessage({ id: "profile.day_month_year_birth" })}</label>
          <DateTextBox
            style={{ color: "rgba(0,0,0,.87)" }}
            disabled={props.readOnly}
            placeholder="เลือกวันที่"
            value={props.userData.birthdate}
            onChange={(value) => {
              props.onChangeValue(null, { name: "birthdate", value });
            }}
          />
        </FormField>
      </FormGroup>

      <FormGroup inline>
        <FormField width={8} required>
          <label>Email</label>
          <Input
            name="email"
            placeholder="กรุณาระบุอีเมลให้ถูกต้อง"
            readOnly={props.readOnly}
            value={props.userData.email}
            onChange={props.onChangeValue}
          />
        </FormField>
        <FormField width={1} />
        <FormField width={8} required>
          <label>เบอร์โทร</label>
          <Input
            name="phone_no"
            placeholder="กรุณาระบุหมายเลขโทรศัพท์"
            readOnly={props.readOnly}
            value={props.userData.phone_no}
            onChange={props.onChangeValue}
          />
        </FormField>
      </FormGroup>

      <br />
      <br />
      {!props.readOnly && (
        <div className="last-div">
          <Button
            style={{ backgroundColor: "var(--primary-theme-color)", color: "white" }}
            loading={props.isSaveLoading}
            type="submit"
            onClick={props.onSave}
          >
            บันทึก
          </Button>
        </div>
      )}
    </Form>
  );
};

export default UserProfileFormDetailed;
